export const menuAnalys = [
    {
        id: 1,
        label: "menuitems.menu.text",
        isTitle: true
    },
    {
        id: 2,
        label: "menuitems.dashboards.text",
        icon: "bx-home",
        link: "/"
    },
    {
        id: 3,
        label: "menuitems.project.text",
        icon: "bx-detail",
        link: "/project"
    },
    {
        id: 4,
        label: "menuitems.apps.text",
        isTitle: true
    },
    {
        id: 5,
        label: "Twitter",
        icon: "bxl-twitter",
        link: "/twitter"
    },
    {
        id: 6,
        label: "Instagram",
        icon: "bxl-instagram-alt",
        link: "/instagram",
    },
    {
        id: 7,
        label: "Facebook",
        icon: "bxl-facebook-square",
        link: "/facebook",
    },
    {
        id: 8,
        label: "Youtube",
        icon: "bx bxl-youtube",
        link: "/youtube",
    },
    {
        id: 9,
        label: "Tiktok",
        icon: "bx bxs-playlist",
        link: "/tiktok",
    },

    {
        id: 10,
        label: "menuitems.apps-group.text",
        isTitle: true
    },
    {
        id: 11,
        label: "Telegram",
        icon: "bxl-telegram",
        link: "/group-telegram"
    },
    {
        id: 20,
        label: "menuitems.web.text",
        isTitle: true
    },
    {
        id: 21,
        label: "menuitems.news-article.text",
        icon: "bx bx-news",
        link: "/news"
    },
    {
        id: 22,
        label: "NLP",
        icon: "bx bx-news",
        link: "/nlp"
    },

    {
        id: 30,
        label: "menuitems.apps-phone.text",
        isTitle: true
    },
    {
        id: 31,
        label: "menuitems.number-format.text",
        icon: "bxl-whatsapp",
        link: "/phone-number"
    },

    // {
    //     id: 32,
    //     label: "menuitems.number-tags.text",
    //     icon: "bxl-whatsapp",
    //     link: "/phone-tags"
    // },
    // {
    //     id: 33,
    //     label: "menuitems.number-search.text",
    //     icon: "bxl-whatsapp",
    //     link: "/phone-search"
    // },
    // {
    //     id: 34,
    //     label: "menuitems.apps-education.text",
    //     isTitle: true
    // },
    // {
    //     id: 35,
    //     label: "menuitems.education-career.text",
    //     icon: "bx bx-id-card",
    //     subItems: [
    //         {
    //             id: 36,
    //             label: "menuitems.education.text",
    //             link: "/education-search",
    //             parentId: 61
    //         },
    //         {
    //             id: 37,
    //             label: "menuitems.career.text",
    //             link: "/career-search",
    //             parentId:  61
    //         },
    //     ],
    // },
    // {
    //     id: 38,
    //     label: "menuitems.exposed-credential.text",
    //     icon: "bx bx-search-alt-2",
    //     link: "/exposed-credential"
    // },
    {
        id: 40,
        label: "menuitems.apps-advanced.text",
        isTitle: true
    },
    {
        id: 41,
        label: "Website",
        icon: "bx bx-world",
        subItems: [
            {
                id: 411,
                label: "menuitems.website-info.text",
                link: "/website-info",
                parentId: 41
            },
            {
                id: 412,
                label: "menuitems.domain-whois-lookup.text",
                link: "/domain-whois",
                parentId: 41
            },
            {
                id: 413,
                label: "menuitems.find-website.text",
                link: "/find-website",
                parentId: 41
            },
            {
                id: 414,
                label: "menuitems.domain-age-checker.text",
                link: "/age-checker",
                parentId: 41
            },
            {
                id: 415,
                label: "menuitems.services-checker.text",
                link: "/web-service",
                parentId: 41
            },
            {
                id: 416,
                label: "menuitems.subdomain-checker.text",
                link: "/subdomain-checker",
                parentId: 41
            },
            {
                id: 417,
                label: "menuitems.cms-checker.text",
                link: "/cms-checker",
                parentId: 41
            },
        ],
    },
    {
        id: 42,
        label: "menuitems.education-career.text",
        icon: "bx bx-id-card",
        subItems: [
            {
                id: 421,
                label: "menuitems.education.text",
                link: "/education-search",
                parentId: 42
            },
            {
                id: 422,
                label: "menuitems.career.text",
                link: "/career-search",
                parentId: 42
            },
        ],
    },
    {
        id: 43,
        label: "menuitems.advanced-search.text",
        icon: "bx bx-search-alt-2",
        link: "/advanced-search"
    },
    {
        id: 45,
        label: "menuitems.exposed-credential.text",
        icon: "bx bx-key",
        link: "/potential-breach"
    },
    {
        id: 46,
        label: "OCR",
        icon: "bx bx-image",
        link: "/ocr"
    },
    {
        id: 50,
        label: "menuitems.apps-geo.text",
        isTitle: true
    },
    {
        id: 51,
        label: "menuitems.visual.text",
        icon: "bx bxs-map-pin",
        link: "/visual-surveillance"
    },
    {
        id: 60,
        label: "menuitems.citizen_db.text",
        isTitle: true
    },
    {
        id: 61,
        label: "menuitems.indonesian.text",
        icon: "bx-flag",
        link: "/citizen"
    },
    // {
    //     id: 62,
    //     label: "menuitems.other-country.text",
    //     icon: "bx-flag",
    //     link: "/"
    // },
    // {
    //     id: 70,
    //     label: "menuitems.application.text",
    //     isTitle: true
    // },
    // {
    //     id: 71,
    //     label: "menuitems.user_management.text",
    //     icon: "bx-user",
    //     link: "/user-management"
    // },
    // {
    //     id: 72,
    //     label: "menuitems.setting.text",
    //     icon: "bx-cog",
    //     subItems: [
    //         {
    //             id: 73,
    //             label: "menuitems.category.text",
    //             link: "/category",
    //             parentId: 72
    //         },
    //         {
    //             id: 74,
    //             label: "menuitems.cctv.text",
    //             link: "/cctv",
    //             parentId: 72
    //         },
    //         {
    //             id: 75,
    //             label: "menuitems.preferences.text",
    //             link: "/preferences",
    //             parentId: 72
    //         },
    //         {
    //             id: 76,
    //             label: "menuitems.pref-news.text",
    //             link: "/pref-news",
    //             parentId: 72
    //         },
    //     ],
    // },

];
